import logo from './logo.svg';
import './App.css';
import { HomePage } from './homepage';
import { MenuBar } from './MenuBar';
import { AktualnosciPage } from './aktualnosci';
import { AboutUs } from './aboutus';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RocznikiPage } from './rocznikiPage';
import { EventsCalendar } from './eventsCalendar';
import EventCreator from './addEvent';
import { AddNewsForm } from './dodawanieAktualnosci';
import { TextEditorForm } from './tekstEditor';
import { EventsForm } from './scheduledEventsEditor';
import PhotoManager from './photoManager';
import RocznikManager from './RocznikManager';
import WynikiForm from './resultsManager';
import MiejscaGier from './gamesManager';
import { AdminPage } from './adminPage';
import { useLocation } from 'react-router-dom';
import { ContactPage } from './contactPage';
import { AdminKafelki } from './adminTiles';
import { AdminInbox } from './adminInbox';
import { Footer } from './footer';
import { Admin } from './admin';
function RootApp() {
  const location = useLocation(); // hook do sprawdzania ścieżki
  return (
    <div className="App">
      {/* Pasek menu nie pojawia się na stronie /admin */}
      {!location.pathname.startsWith("/admin") && <MenuBar />}
      
      <Routes>
        <Route path="/admin/old" element={<AdminPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/aktualnosci" element={<AktualnosciPage />} />
        <Route path="/kim-jestesmy" element={<AboutUs />} />
        {/* <Route path="/roczniki" element={<RocznikiPage />} /> */}
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/admin/*" element={<Admin />} />
      </Routes>

      {/* STOPKA PRZENIESIONA TUTAJ: Nie pojawia się na stronie admina */}
      {!location.pathname.startsWith("/admin") && <Footer />}
    </div>
  );
}

function App() {
  // USUNIĘTO useLocation() Z TEGO MIEJSCA
  return (
    <BrowserRouter>
      <div className='main'>
        <RootApp />
      </div>
    </BrowserRouter>
  );
}
export default App;